// Teaser (public site) behaviour. Every part guards for its markup, because sections can be removed in the editor.
(function () {
  // Hamburger menu (rendered by snippets/tz-chrome.liquid)
  var panel = document.getElementById('menu-panel');
  var open = document.getElementById('menu-open');
  var close = document.getElementById('menu-close');
  if (panel && open && close) {
    var show = function () { panel.hidden = false; };
    var hide = function () { panel.hidden = true; };
    open.addEventListener('click', show);
    close.addEventListener('click', hide);
    panel.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }

  // Carousel arrows: scroll one visible "page"; hide the arrows when every slide already fits.
  document.querySelectorAll('[data-car]').forEach(function (car) {
    var track = car.querySelector('.car__track');
    var prev = car.querySelector('.car__btn--prev');
    var next = car.querySelector('.car__btn--next');
    if (!track || !prev || !next) return;
    // One slide per click, wrapping at both ends (client feedback: arrows must always switch photos).
    function step() {
      var slide = track.querySelector('.car__slide:not(.car__slide--sp), .car__slide');
      return slide ? slide.getBoundingClientRect().width + 2 : track.clientWidth;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    prev.addEventListener('click', function () {
      if (track.scrollLeft <= 1) track.scrollTo({ left: maxScroll(), behavior: 'smooth' });
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      if (track.scrollLeft >= maxScroll() - 1) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    function syncArrows() {
      var scrollable = track.scrollWidth > track.clientWidth + 1;
      prev.hidden = !scrollable;
      next.hidden = !scrollable;
    }
    syncArrows();
    window.addEventListener('resize', syncArrows);
  });

  // Language switch: show the chosen language, swap form placeholders, keep ?lang=ja in the URL.
  function applyLang(lang) {
    document.documentElement.lang = lang;
    document.querySelectorAll('[data-ph-en]').forEach(function (el) {
      el.placeholder = el.getAttribute('data-ph-' + lang);
    });
  }
  document.querySelectorAll('[data-set-lang]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var lang = a.getAttribute('data-set-lang');
      applyLang(lang);
      var url = new URL(location.href);
      if (lang === 'ja') url.searchParams.set('lang', 'ja');
      else url.searchParams.delete('lang');
      history.replaceState(null, '', url.toString());
    });
  });
  applyLang(document.documentElement.lang === 'ja' ? 'ja' : 'en');

  // JOIN: gz-app (App Proxy /apps/gsl/join, LM-2032) registers the customer; Flow sends the email.
  // Response: {ok:true} or {ok:false, errors:[{field, message}]} (messages already localized by lang).
  var form = document.getElementById('join-form');
  var thanks = document.getElementById('join-thanks');
  var errorBox = document.getElementById('join-error');
  if (!form || !thanks || !errorBox) return;
  var sendButton = form.querySelector('button[type="submit"]');
  var GENERIC_ERROR = {
    en: 'Something went wrong. Please try again later.',
    ja: 'エラーが発生しました。時間をおいて再度お試しください。'
  };
  function showErrors(messages) {
    errorBox.textContent = '';
    messages.forEach(function (message) {
      var line = document.createElement('span');
      line.textContent = message;
      errorBox.appendChild(line);
    });
    errorBox.hidden = messages.length === 0;
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sendButton.disabled) return;
    var lang = document.documentElement.lang === 'ja' ? 'ja' : 'en';
    var body = new URLSearchParams(new FormData(form));
    body.set('lang', lang);
    form.querySelectorAll('[aria-invalid]').forEach(function (el) { el.removeAttribute('aria-invalid'); });
    showErrors([]);
    sendButton.disabled = true;
    sendButton.dataset.state = 'sending';
    fetch('/apps/gsl/join', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json().catch(function () { return { ok: false, errors: [] }; });
      })
      .then(function (data) {
        if (data && data.ok) {
          sendButton.dataset.state = 'done';
          setTimeout(function () { form.hidden = true; thanks.hidden = false; }, 900);
          return;
        }
        sendButton.dataset.state = '';
        sendButton.disabled = false;
        var errors = (data && data.errors) || [];
        errors.forEach(function (error) {
          var field = error.field && form.querySelector('[name="' + error.field + '"]');
          if (field) field.setAttribute('aria-invalid', 'true');
        });
        var messages = errors.map(function (error) { return error.message; }).filter(Boolean);
        showErrors(messages.length ? messages : [GENERIC_ERROR[lang]]);
      })
      .catch(function () {
        showErrors([GENERIC_ERROR[lang]]);
        sendButton.dataset.state = '';
        sendButton.disabled = false;
      });
  });
})();
